import logo from '@fv/client-assets/freightview.svg'

export const Branding = () => (
  <div className="flex gap-x-2 mt-auto px-6 py-3 justify-center flex-none">
    <img alt="Freightview" src={logo} />
    <span>Carrier</span>
  </div>
)
